(function () {
  var body = document.body;
  var header = document.querySelector("[data-site-header]");
  var menuToggle = document.querySelector("[data-mobile-toggle]");
  var menuClose = document.querySelector("[data-mobile-close]");
  var mobileNav = document.querySelector("[data-mobile-nav]");
  var mobileBackdrop = document.querySelector("[data-mobile-backdrop]");
  var mobileSearchForm = document.querySelector("[data-mobile-search]");
  var mobileSearchToggle = document.querySelector("[data-mobile-search-toggle]");
  var mobileSearchInput = document.querySelector("[data-mobile-search-input]");
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var themeStrings = { addToCart: "加入購物車", soldOut: "售完" };
  var themeStringsScript = document.getElementById("LumiThemeStrings");

  if (themeStringsScript) {
    try {
      themeStrings = Object.assign(themeStrings, JSON.parse(themeStringsScript.textContent || "{}"));
    } catch (error) {
      themeStrings = { addToCart: "加入購物車", soldOut: "售完" };
    }
  }

  var progress = document.createElement("div");
  progress.className = "la-scroll-progress";
  progress.setAttribute("aria-hidden", "true");
  document.body.appendChild(progress);

  var cursorGlow = document.createElement("div");
  cursorGlow.className = "la-cursor-glow";
  cursorGlow.setAttribute("aria-hidden", "true");
  document.body.appendChild(cursorGlow);

  function syncHeaderState() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  }

  function syncScrollProgress() {
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    var progressValue = maxScroll > 0 ? window.scrollY / maxScroll : 0;
    progress.style.transform = "scaleX(" + Math.min(Math.max(progressValue, 0), 1) + ")";
  }

  function closeMobileMenu() {
    body.classList.remove("mobile-menu-open");
    closeMobileSearch();

    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "false");
    }

    if (mobileNav) {
      mobileNav.setAttribute("aria-hidden", "true");
      mobileNav.classList.remove("is-open");
    }

    if (mobileBackdrop) {
      mobileBackdrop.classList.remove("is-open");
    }
  }

  function openMobileMenu() {
    body.classList.add("mobile-menu-open");

    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "true");
    }

    if (mobileNav) {
      mobileNav.setAttribute("aria-hidden", "false");
      mobileNav.classList.add("is-open");
    }

    if (mobileBackdrop) {
      mobileBackdrop.classList.add("is-open");
    }
  }

  function toggleMobileMenu() {
    if (body.classList.contains("mobile-menu-open")) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  }

  function closeMobileSearch() {
    if (mobileSearchForm) {
      mobileSearchForm.classList.remove("is-active");
    }

    if (mobileSearchToggle) {
      mobileSearchToggle.setAttribute("aria-expanded", "false");
    }
  }

  function openMobileSearch() {
    if (mobileSearchForm) {
      mobileSearchForm.classList.add("is-active");
    }

    if (mobileSearchToggle) {
      mobileSearchToggle.setAttribute("aria-expanded", "true");
    }

    window.setTimeout(function () {
      if (mobileSearchInput) mobileSearchInput.focus();
    }, 160);
  }

  syncHeaderState();
  syncScrollProgress();

  window.addEventListener("scroll", syncHeaderState, { passive: true });
  window.addEventListener("scroll", syncScrollProgress, { passive: true });
  window.addEventListener("resize", syncScrollProgress);

  /* =========================================================
     FINAL FIX:
     手機 menu 打開後，如果視窗放大到桌機版，自動關閉 sidebar
  ========================================================= */

  var mobileMenuDesktopMedia = window.matchMedia("(min-width: 981px)");

  function closeMobileMenuOnDesktop() {
    if (!mobileMenuDesktopMedia.matches) return;
    closeMobileMenu();
  }

  window.addEventListener("resize", closeMobileMenuOnDesktop);

  if (mobileMenuDesktopMedia.addEventListener) {
    mobileMenuDesktopMedia.addEventListener("change", closeMobileMenuOnDesktop);
  } else if (mobileMenuDesktopMedia.addListener) {
    mobileMenuDesktopMedia.addListener(closeMobileMenuOnDesktop);
  }

  var headerSearchToggle = document.querySelector("[data-header-search-toggle]");
  var headerSearchPanel = document.querySelector("[data-header-search-panel]");
  var headerSearchInput = document.querySelector("[data-header-search-input]");
  var headerSearchClose = document.querySelector("[data-header-search-close]");

  function closeHeaderSearch() {
    body.classList.remove("header-search-open");

    if (headerSearchToggle) {
      headerSearchToggle.setAttribute("aria-expanded", "false");
    }

    if (headerSearchPanel) {
      headerSearchPanel.classList.remove("is-active");
    }
  }

  function openHeaderSearch() {
    closeMobileMenu();
    closeLanguageMenus();
    body.classList.add("header-search-open");

    if (headerSearchToggle) {
      headerSearchToggle.setAttribute("aria-expanded", "true");
    }

    if (headerSearchPanel) {
      headerSearchPanel.classList.add("is-active");
    }

    window.setTimeout(function () {
      if (headerSearchInput) headerSearchInput.focus();
    }, 180);
  }

  if (headerSearchToggle) {
    headerSearchToggle.addEventListener("click", function (event) {
      if (body.classList.contains("header-search-open")) {
        if (headerSearchInput && headerSearchInput.value.trim()) {
          if (headerSearchPanel && typeof headerSearchPanel.requestSubmit === "function") {
            headerSearchPanel.requestSubmit();
          } else if (headerSearchPanel) {
            headerSearchPanel.submit();
          }
        } else {
          event.preventDefault();
          if (headerSearchInput) headerSearchInput.focus();
        }
      } else {
        openHeaderSearch();
      }
    });
  }

  if (headerSearchClose) {
    headerSearchClose.addEventListener("click", closeHeaderSearch);
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeHeaderSearch();
    }
  });

  document.addEventListener("click", function (event) {
    if (!body.classList.contains("header-search-open")) return;
    if (!headerSearchPanel || !headerSearchToggle) return;
    if (headerSearchPanel.contains(event.target) || headerSearchToggle.contains(event.target)) return;

    closeHeaderSearch();
  });

  function submitLocalizationForm(select) {
    if (!select.form) return;

    var isLocalPreview = window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost";

    if (isLocalPreview) {
      var shopDomain = select.form.getAttribute("data-shop-domain");
      var themeId = select.form.getAttribute("data-theme-id");

      if (shopDomain) {
        var remoteForm = document.createElement("form");
        remoteForm.method = "post";
        remoteForm.action = "https://" + shopDomain + "/localization";
        remoteForm.style.display = "none";

        [
          ["_method", "put"],
          ["language_code", select.value],
          ["return_to", "/?preview_theme_id=" + (themeId || "203815321886")]
        ].forEach(function (field) {
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = field[0];
          input.value = field[1];
          remoteForm.appendChild(input);
        });

        document.body.appendChild(remoteForm);
        remoteForm.submit();
        return;
      }
    }

    select.form.submit();
  }

  document.querySelectorAll("[data-language-select]").forEach(function (select) {
    select.addEventListener("change", function () {
      if (window.localStorage) {
        window.localStorage.setItem("lumi_locale_auto_selected", select.value || "manual");
      }

      submitLocalizationForm(select);
    });
  });

  function closeLanguageMenus(exceptMenu) {
    document.querySelectorAll("[data-language-menu]").forEach(function (menu) {
      if (exceptMenu && menu === exceptMenu) return;
      menu.classList.remove("is-open");

      var trigger = menu.querySelector("[data-language-trigger]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
  }

  document.querySelectorAll("[data-language-menu]").forEach(function (menu) {
    var form = menu.closest("form");
    var select = form ? form.querySelector("[data-language-select]") : null;
    var trigger = menu.querySelector("[data-language-trigger]");
    var current = menu.querySelector("[data-language-current]");
    var options = menu.querySelectorAll("[data-language-option]");

    if (!select || !trigger) return;

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      var shouldOpen = !menu.classList.contains("is-open");
      closeLanguageMenus(menu);
      menu.classList.toggle("is-open", shouldOpen);
      trigger.setAttribute("aria-expanded", String(shouldOpen));
    });

    options.forEach(function (option) {
      option.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var code = option.getAttribute("data-language-code");
        if (!code) return;

        select.value = code;
        if (current) current.textContent = option.textContent.trim();

        options.forEach(function (item) {
          var isActive = item === option;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-selected", String(isActive));
        });

        closeLanguageMenus();

        if (window.localStorage) {
          window.localStorage.setItem("lumi_locale_auto_selected", code);
        }

        submitLocalizationForm(select);
      });
    });
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-language-menu]")) return;
    closeLanguageMenus();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeLanguageMenus();
    }
  });

  (function autoSelectVisitorLanguage() {
    var autoLocaleKey = "lumi_locale_auto_selected";
    if (window.localStorage && window.localStorage.getItem(autoLocaleKey)) return;

    var select = document.querySelector("[data-language-select]");
    if (!select || !select.form) return;

    var available = Array.prototype.slice.call(select.options).map(function (option) {
      return option.value;
    });

    var current = select.value;
    var country = (document.documentElement.getAttribute("data-country") || "").toUpperCase();
    var countryLocaleMap = {
      TW: ["zh-TW", "zh-Hant", "zh"],
      HK: ["zh-TW", "zh-Hant", "zh"],
      MO: ["zh-TW", "zh-Hant", "zh"],
      JP: ["ja", "ja-JP"],
      KR: ["ko", "ko-KR"],
      ES: ["es", "es-ES"],
      MX: ["es", "es-MX", "es"],
      AR: ["es", "es-AR", "es"],
      CO: ["es", "es-CO", "es"],
      CL: ["es", "es-CL", "es"],
      PE: ["es", "es-PE", "es"],
      SA: ["ar", "ar-SA"],
      AE: ["ar", "ar-AE"],
      QA: ["ar", "ar-QA"],
      KW: ["ar", "ar-KW"],
      EG: ["ar", "ar-EG"],
      US: ["en", "en-US"],
      GB: ["en", "en-GB"],
      CA: ["en", "en-CA"],
      AU: ["en", "en-AU"],
      SG: ["en", "en-SG"]
    };
    var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    var target = "";

    function pickAvailable(candidates) {
      return candidates.some(function (candidate) {
        if (available.indexOf(candidate) > -1) {
          target = candidate;
          return true;
        }

        var base = (candidate || "").split("-")[0];
        if (base && available.indexOf(base) > -1) {
          target = base;
          return true;
        }

        return false;
      });
    }

    if (country && countryLocaleMap[country]) {
      pickAvailable(countryLocaleMap[country]);
    }

    if (!target) languages.some(function (language) {
      var normalized = (language || "").toLowerCase();
      var candidates = [];

      if (normalized.indexOf("zh") === 0) {
        candidates = ["zh-TW", "zh-Hant", "zh"];
      } else if (normalized.indexOf("ja") === 0) {
        candidates = ["ja", "ja-JP"];
      } else if (normalized.indexOf("ko") === 0) {
        candidates = ["ko", "ko-KR"];
      } else if (normalized.indexOf("es") === 0) {
        candidates = ["es", "es-ES"];
      } else if (normalized.indexOf("ar") === 0) {
        candidates = ["ar", "ar-SA"];
      } else if (normalized.indexOf("en") === 0) {
        candidates = ["en", "en-US"];
      } else {
        candidates = [language];
      }

      return pickAvailable(candidates);
    });

    if (target && target !== current) {
      if (window.localStorage) window.localStorage.setItem(autoLocaleKey, target);
      return;
    } else if (window.localStorage) {
      window.localStorage.setItem(autoLocaleKey, current || "default");
    }
  })();

  function initIndexLiquidBackgrounds(desktopMedia) {
    var sections = Array.prototype.slice.call(
      document.querySelectorAll("main .shopify-section > section")
    ).filter(function (section, index, list) {
      return section && list.indexOf(section) === index;
    });

    if (!sections.length) return;

    document.querySelectorAll(".la-liquid-lens, #la-liquid-displace-svg, .la-water-ripple-surface").forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    var vertexSource =
      "attribute vec2 a_position;" +
      "varying vec2 v_uv;" +
      "void main(){v_uv=(a_position+1.0)*0.5;gl_Position=vec4(a_position,0.0,1.0);}";

    var fragmentSource =
      "precision mediump float;" +
      "varying vec2 v_uv;" +
      "uniform sampler2D u_texture;" +
      "uniform vec2 u_resolution;" +
      "uniform float u_time;" +
      "uniform float u_opacity;" +
      "uniform int u_count;" +
      "uniform vec4 u_points[18];" +
      "void main(){" +
      "vec2 uv=v_uv;" +
      "vec2 aspect=vec2(u_resolution.x/u_resolution.y,1.0);" +
      "vec2 flow=vec2(0.0);" +
      "float ridge=0.0;" +
      "for(int i=0;i<18;i++){" +
      "if(i>=u_count) break;" +
      "vec4 p=u_points[i];" +
      "float age=max(u_time-p.z,0.0);" +
      "float life=exp(-age*1.1)*p.w;" +
      "vec2 d=(uv-p.xy)*aspect;" +
      "float dist=length(d)+0.0005;" +
      "float wave=sin(dist*58.0-age*8.8)*exp(-dist*5.0)*life;" +
      "float swell=exp(-dist*12.0)*life;" +
      "flow+=normalize(d)*(wave*0.036+swell*0.024);" +
      "ridge+=abs(wave)*exp(-dist*1.6);" +
      "}" +
      "vec2 warped=uv+flow;" +
      "vec4 base=texture2D(u_texture,uv);" +
      "vec4 c1=texture2D(u_texture,warped+flow*0.34);" +
      "vec4 c2=texture2D(u_texture,warped-flow*0.2);" +
      "vec3 color=vec3(c1.r,mix(c1.g,c2.g,0.45),c2.b);" +
      "float shine=smoothstep(0.02,0.24,ridge)*0.34;" +
      "color=mix(base.rgb,color,0.72);" +
      "color=mix(color,vec3(0.95,0.89,0.8),0.16)*0.92;" +
      "color+=vec3(1.0,0.94,0.82)*shine;" +
      "gl_FragColor=vec4(color,u_opacity);" +
      "}";

    function compile(gl, type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
      return shader;
    }

    function getBackgroundUrl(section) {
      var styles = [
        window.getComputedStyle(section),
        window.getComputedStyle(section, "::before"),
        window.getComputedStyle(section, "::after")
      ];

      for (var index = 0; index < styles.length; index += 1) {
        var image = styles[index].backgroundImage || "";
        var match = image.match(/url\\([\"']?([^\"')]+)[\"']?\\)/);
        if (match && match[1]) return match[1];
      }

      var img = section.querySelector("img");
      return img ? img.currentSrc || img.src : "";
    }

    function createFallbackTexture(section) {
      var rect = section.getBoundingClientRect();
      var canvas = document.createElement("canvas");
      var width = Math.max(960, Math.round(rect.width || window.innerWidth));
      var height = Math.max(540, Math.round(rect.height || 720));
      var ctx = canvas.getContext("2d");
      var bg = window.getComputedStyle(section).backgroundColor || "#f8f3ea";

      canvas.width = width;
      canvas.height = height;

      var gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, bg === "rgba(0, 0, 0, 0)" ? "#f8f3ea" : bg);
      gradient.addColorStop(0.58, "#f4ecdf");
      gradient.addColorStop(1, "#e9ddcc");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
      ctx.strokeStyle = "rgba(20,20,20,0.055)";
      ctx.lineWidth = 1;
      for (var x = 0; x < width; x += 64) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
        ctx.stroke();
      }
      for (var y = 0; y < height; y += 64) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(width, y);
        ctx.stroke();
      }

      return canvas;
    }

    function createItem(section) {
      var canvas = document.createElement("canvas");
      var gl = canvas.getContext("webgl", {
        alpha: true,
        antialias: true,
        depth: false,
        stencil: false,
        premultipliedAlpha: true
      });

      if (!gl) return null;

      var vertex = compile(gl, gl.VERTEX_SHADER, vertexSource);
      var fragment = compile(gl, gl.FRAGMENT_SHADER, fragmentSource);
      if (!vertex || !fragment) return null;

      var program = gl.createProgram();
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;

      canvas.className = "la-liquid-bg-canvas";
      canvas.setAttribute("aria-hidden", "true");
      section.classList.add("la-liquid-bg-section");
      section.insertBefore(canvas, section.firstChild);

      var buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
        gl.STATIC_DRAW
      );

      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

      var item = {
        section: section,
        canvas: canvas,
        gl: gl,
        program: program,
        position: gl.getAttribLocation(program, "a_position"),
        resolution: gl.getUniformLocation(program, "u_resolution"),
        time: gl.getUniformLocation(program, "u_time"),
        opacity: gl.getUniformLocation(program, "u_opacity"),
        count: gl.getUniformLocation(program, "u_count"),
        pointsUniform: gl.getUniformLocation(program, "u_points"),
        texture: texture,
        source: null,
        points: [],
        lastPointAt: 0,
        textureReady: false,
        textureFailed: false
      };

      var video = section.querySelector(".la-hero-bg-video-wrap video");
      var bgUrl = getBackgroundUrl(section);

      if (video) {
        var videoSource = video.currentSrc || (video.querySelector("source") && video.querySelector("source").src) || "";
        var textureVideo = document.createElement("video");
        textureVideo.crossOrigin = "anonymous";
        textureVideo.muted = true;
        textureVideo.loop = true;
        textureVideo.playsInline = true;
        textureVideo.preload = "auto";
        textureVideo.src = videoSource;
        textureVideo.addEventListener("canplay", function () {
          item.textureReady = true;
          textureVideo.play().catch(function () {});
        });
        textureVideo.load();
        item.source = textureVideo;
      } else if (bgUrl) {
        var image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = function () {
          item.source = image;
          item.textureReady = true;
        };
        image.onerror = function () {
          item.source = createFallbackTexture(section);
          item.textureReady = true;
        };
        image.src = bgUrl;
      } else {
        item.source = createFallbackTexture(section);
        item.textureReady = true;
      }

      if (section.id === "lumi-services") {
        section.querySelectorAll(".la-service-card").forEach(function (card) {
          card.addEventListener("pointerenter", function () {
            var cardImage = card.querySelector("img");
            var nextSrc = cardImage ? cardImage.currentSrc || cardImage.src : "";
            if (!nextSrc) return;
            var image = new Image();
            image.crossOrigin = "anonymous";
            image.onload = function () {
              item.source = image;
              item.textureReady = true;
            };
            image.src = nextSrc;
          });
        });
      }

      return item;
    }

    var items = sections.map(createItem).filter(Boolean);
    var globalPoints = [];
    var raf = null;

    function resize(item) {
      var rect = item.section.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var width = Math.max(2, Math.round(rect.width * dpr));
      var height = Math.max(2, Math.round(rect.height * dpr));
      if (item.canvas.width !== width || item.canvas.height !== height) {
        item.canvas.width = width;
        item.canvas.height = height;
      }
      item.canvas.style.width = rect.width + "px";
      item.canvas.style.height = rect.height + "px";
      return rect;
    }

    function uploadTexture(item) {
      if (!item.textureReady || !item.source) return false;
      var gl = item.gl;
      var source = item.source;

      if (source.tagName === "VIDEO" && source.readyState < 2) return false;

      try {
        gl.bindTexture(gl.TEXTURE_2D, item.texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
        item.textureFailed = false;
        return true;
      } catch (error) {
        if (!item.textureFailed) {
          item.source = createFallbackTexture(item.section);
          item.textureReady = true;
          item.textureFailed = true;
        }
        return false;
      }
    }

    function draw(item, now) {
      var rect = resize(item);
      if (rect.bottom < -80 || rect.top > window.innerHeight + 80) return;
      if (!uploadTexture(item)) return;

      var gl = item.gl;
      var visiblePoints = globalPoints.filter(function (point) {
        return now - point.t < 2.6;
      }).map(function (point) {
        return {
          x: (point.x - rect.left) / rect.width,
          y: 1 - (point.y - rect.top) / rect.height,
          t: point.t,
          s: point.s
        };
      }).filter(function (point) {
        return point.x > -0.25 && point.x < 1.25 && point.y > -0.25 && point.y < 1.25;
      }).slice(-18);

      gl.viewport(0, 0, item.canvas.width, item.canvas.height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(item.program);
      gl.enableVertexAttribArray(item.position);
      gl.vertexAttribPointer(item.position, 2, gl.FLOAT, false, 0, 0);
      gl.uniform2f(item.resolution, item.canvas.width, item.canvas.height);
      gl.uniform1f(item.time, now);
      gl.uniform1f(item.opacity, item.section.classList.contains("la-detroit-hero") ? 0.78 : 0.66);
      gl.uniform1i(item.count, visiblePoints.length);

      var data = new Float32Array(18 * 4);
      visiblePoints.forEach(function (point, index) {
        data[index * 4] = point.x;
        data[index * 4 + 1] = point.y;
        data[index * 4 + 2] = point.t;
        data[index * 4 + 3] = point.s;
      });
      gl.uniform4fv(item.pointsUniform, data);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
    }

    function render() {
      var now = (window.performance ? window.performance.now() : Date.now()) / 1000;
      globalPoints = globalPoints.filter(function (point) {
        return now - point.t < 2.6;
      });
      items.forEach(function (item) {
        draw(item, now);
      });
      raf = window.requestAnimationFrame(render);
    }

    document.addEventListener("pointermove", function (event) {
      if (!desktopMedia.matches) return;
      var now = (window.performance ? window.performance.now() : Date.now()) / 1000;
      var last = globalPoints[globalPoints.length - 1];
      if (last && now - last.t < 0.026) return;
      var strength = last ? Math.min(Math.hypot(event.clientX - last.x, event.clientY - last.y) / 52, 1) : 0.45;
      globalPoints.push({ x: event.clientX, y: event.clientY, t: now, s: Math.max(0.28, strength) });
      while (globalPoints.length > 18) globalPoints.shift();
    }, { passive: true });

    window.addEventListener("resize", function () {
      items.forEach(resize);
    });

    items.forEach(resize);
    render();
  }

  function initIndexLiquidBackgrounds(desktopMedia) {
    var sections = Array.prototype.slice.call(
      document.querySelectorAll("main .shopify-section > section")
    ).filter(function (section, index, list) {
      return section && list.indexOf(section) === index;
    });

    if (!sections.length) return;

    document.querySelectorAll(".la-liquid-lens, #la-liquid-displace-svg, .la-water-ripple-surface").forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    var vertexSource =
      "attribute vec2 a_position;" +
      "varying vec2 v_uv;" +
      "void main(){v_uv=(a_position+1.0)*0.5;gl_Position=vec4(a_position,0.0,1.0);}";

    var simulationFragmentSource =
      "precision mediump float;" +
      "varying vec2 v_uv;" +
      "uniform sampler2D u_state;" +
      "uniform vec2 u_resolution;" +
      "uniform vec2 u_mouse;" +
      "uniform float u_mouse_active;" +
      "void main(){" +
      "vec2 px=1.0/u_resolution;" +
      "vec4 s=texture2D(u_state,v_uv);" +
      "float h=s.r*2.0-1.0;" +
      "float prev=s.g*2.0-1.0;" +
      "float l=texture2D(u_state,v_uv-vec2(px.x,0.0)).r*2.0-1.0;" +
      "float r=texture2D(u_state,v_uv+vec2(px.x,0.0)).r*2.0-1.0;" +
      "float b=texture2D(u_state,v_uv-vec2(0.0,px.y)).r*2.0-1.0;" +
      "float t=texture2D(u_state,v_uv+vec2(0.0,px.y)).r*2.0-1.0;" +
      "float lap=(l+r+b+t-4.0*h);" +
      "float next=(2.0*h-prev)+lap*0.38;" +
      "next*=0.968;" +
      "vec2 aspect=vec2(u_resolution.x/u_resolution.y,1.0);" +
      "vec2 d=(v_uv-u_mouse)*aspect;" +
      "float head=exp(-dot(d,d)*1800.0)*u_mouse_active;" +
      "next+=head*0.62;" +
      "next=clamp(next,-1.0,1.0);" +
      "gl_FragColor=vec4(next*0.5+0.5,h*0.5+0.5,0.5,1.0);" +
      "}";

    var renderFragmentSource =
      "precision mediump float;" +
      "varying vec2 v_uv;" +
      "uniform sampler2D u_background;" +
      "uniform sampler2D u_state;" +
      "uniform vec2 u_resolution;" +
      "uniform float u_opacity;" +
      "void main(){" +
      "vec2 px=1.0/u_resolution;" +
      "float h=texture2D(u_state,v_uv).r*2.0-1.0;" +
      "float hx=(texture2D(u_state,v_uv+vec2(px.x*2.0,0.0)).r-texture2D(u_state,v_uv-vec2(px.x*2.0,0.0)).r)*2.0;" +
      "float hy=(texture2D(u_state,v_uv+vec2(0.0,px.y*2.0)).r-texture2D(u_state,v_uv-vec2(0.0,px.y*2.0)).r)*2.0;" +
      "vec2 normal=vec2(hx,hy);" +
      "float normalStrength=length(normal);" +
      "normal*=smoothstep(0.018,0.08,normalStrength);" +
      "vec2 uv=v_uv+normal*0.052;" +
      "float edge=smoothstep(0.045,0.18,length(normal));" +
      "edge=pow(edge,2.4);" +
      "vec3 color=vec3(" +
      "texture2D(u_background,uv+normal*0.018).r," +
      "texture2D(u_background,uv).g," +
      "texture2D(u_background,uv-normal*0.014).b" +
      ");" +
      "float alpha=edge*0.42*u_opacity;" +
      "gl_FragColor=vec4(color,alpha);" +
      "}";

    function compile(gl, type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
      return shader;
    }

    function createProgram(gl, fragmentSource) {
      var vertex = compile(gl, gl.VERTEX_SHADER, vertexSource);
      var fragment = compile(gl, gl.FRAGMENT_SHADER, fragmentSource);
      if (!vertex || !fragment) return null;
      var program = gl.createProgram();
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      return gl.getProgramParameter(program, gl.LINK_STATUS) ? program : null;
    }

    function setTextureParams(gl) {
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    }

    function createStateTarget(gl, width, height) {
      var texture = gl.createTexture();
      var framebuffer = gl.createFramebuffer();
      var pixels = new Uint8Array(width * height * 4);
      for (var index = 0; index < pixels.length; index += 4) {
        pixels[index] = 128;
        pixels[index + 1] = 128;
        pixels[index + 2] = 128;
        pixels[index + 3] = 255;
      }
      gl.bindTexture(gl.TEXTURE_2D, texture);
      setTextureParams(gl);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
      gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
      return { texture: texture, framebuffer: framebuffer, width: width, height: height };
    }

    function getBackgroundUrl(section) {
      var styles = [
        window.getComputedStyle(section),
        window.getComputedStyle(section, "::before"),
        window.getComputedStyle(section, "::after")
      ];

      for (var index = 0; index < styles.length; index += 1) {
        var image = styles[index].backgroundImage || "";
        var match = image.match(/url\\([\"']?([^\"')]+)[\"']?\\)/);
        if (match && match[1]) return match[1];
      }

      var img = section.querySelector("img");
      return img ? img.currentSrc || img.src : "";
    }

    function createFallbackTexture(section) {
      var rect = section.getBoundingClientRect();
      var canvas = document.createElement("canvas");
      var width = Math.max(960, Math.round(rect.width || window.innerWidth));
      var height = Math.max(540, Math.round(rect.height || 720));
      var ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      var gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, "#f8f3ea");
      gradient.addColorStop(0.55, "#f2eadc");
      gradient.addColorStop(1, "#e8dac7");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
      ctx.strokeStyle = "rgba(20,20,20,0.05)";
      for (var x = 0; x < width; x += 64) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
        ctx.stroke();
      }
      for (var y = 0; y < height; y += 64) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(width, y);
        ctx.stroke();
      }
      return canvas;
    }

    function bindQuad(gl, program, buffer) {
      var position = gl.getAttribLocation(program, "a_position");
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
    }

    function createItem(section) {
      var canvas = document.createElement("canvas");
      var gl = canvas.getContext("webgl", {
        alpha: true,
        antialias: false,
        depth: false,
        stencil: false,
        premultipliedAlpha: true
      });

      if (!gl) return null;

      var simProgram = createProgram(gl, simulationFragmentSource);
      var renderProgram = createProgram(gl, renderFragmentSource);
      if (!simProgram || !renderProgram) return null;

      canvas.className = "la-liquid-bg-canvas";
      canvas.setAttribute("aria-hidden", "true");
      section.classList.add("la-liquid-bg-section");
      section.insertBefore(canvas, section.firstChild);

      var buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);

      var backgroundTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, backgroundTexture);
      setTextureParams(gl);

      var item = {
        section: section,
        canvas: canvas,
        gl: gl,
        buffer: buffer,
        simProgram: simProgram,
        renderProgram: renderProgram,
        backgroundTexture: backgroundTexture,
        source: null,
        textureReady: false,
        textureFailed: false,
        mouseX: -10,
        mouseY: -10,
        mouseActive: 0,
        lastMove: 0,
        stateA: null,
        stateB: null,
        simWidth: 0,
        simHeight: 0
      };

      var video = section.querySelector(".la-hero-bg-video-wrap video");
      var bgUrl = getBackgroundUrl(section);

      if (video) {
        var videoSource = video.currentSrc || (video.querySelector("source") && video.querySelector("source").src) || "";
        var textureVideo = document.createElement("video");
        textureVideo.crossOrigin = "anonymous";
        textureVideo.muted = true;
        textureVideo.loop = true;
        textureVideo.playsInline = true;
        textureVideo.preload = "auto";
        textureVideo.src = videoSource;
        textureVideo.addEventListener("canplay", function () {
          item.textureReady = true;
          textureVideo.play().catch(function () {});
        });
        textureVideo.load();
        item.source = textureVideo;
      } else if (bgUrl) {
        var image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = function () {
          item.source = image;
          item.textureReady = true;
        };
        image.onerror = function () {
          item.source = createFallbackTexture(section);
          item.textureReady = true;
        };
        image.src = bgUrl;
      } else {
        item.source = createFallbackTexture(section);
        item.textureReady = true;
      }

      if (section.id === "lumi-services") {
        section.querySelectorAll(".la-service-card").forEach(function (card) {
          card.addEventListener("pointerenter", function () {
            var cardImage = card.querySelector("img");
            var nextSrc = cardImage ? cardImage.currentSrc || cardImage.src : "";
            if (!nextSrc) return;
            var nextImage = new Image();
            nextImage.crossOrigin = "anonymous";
            nextImage.onload = function () {
              item.source = nextImage;
              item.textureReady = true;
            };
            nextImage.src = nextSrc;
          });
        });
      }

      return item;
    }

    var items = sections.map(createItem).filter(Boolean);

    function resize(item) {
      var rect = item.section.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var width = Math.max(2, Math.round(rect.width * dpr));
      var height = Math.max(2, Math.round(rect.height * dpr));
      var simWidth = Math.max(64, Math.round(width / 2));
      var simHeight = Math.max(64, Math.round(height / 2));

      if (item.canvas.width !== width || item.canvas.height !== height) {
        item.canvas.width = width;
        item.canvas.height = height;
      }

      if (!item.stateA || item.simWidth !== simWidth || item.simHeight !== simHeight) {
        item.stateA = createStateTarget(item.gl, simWidth, simHeight);
        item.stateB = createStateTarget(item.gl, simWidth, simHeight);
        item.simWidth = simWidth;
        item.simHeight = simHeight;
      }

      item.canvas.style.width = rect.width + "px";
      item.canvas.style.height = rect.height + "px";
      return rect;
    }

    function uploadBackground(item) {
      if (!item.textureReady || !item.source) return false;
      var gl = item.gl;
      var source = item.source;
      if (source.tagName === "VIDEO" && source.readyState < 2) return false;

      try {
        gl.bindTexture(gl.TEXTURE_2D, item.backgroundTexture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
        return true;
      } catch (error) {
        if (!item.textureFailed) {
          item.source = createFallbackTexture(item.section);
          item.textureReady = true;
          item.textureFailed = true;
        }
        return false;
      }
    }

    function runSimulation(item, now) {
      var gl = item.gl;
      var active = Math.max(0, 1 - (now - item.lastMove) * 7.5) * item.mouseActive;

      gl.viewport(0, 0, item.simWidth, item.simHeight);
      gl.bindFramebuffer(gl.FRAMEBUFFER, item.stateB.framebuffer);
      gl.useProgram(item.simProgram);
      bindQuad(gl, item.simProgram, item.buffer);
      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, item.stateA.texture);
      gl.uniform1i(gl.getUniformLocation(item.simProgram, "u_state"), 0);
      gl.uniform2f(gl.getUniformLocation(item.simProgram, "u_resolution"), item.simWidth, item.simHeight);
      gl.uniform2f(gl.getUniformLocation(item.simProgram, "u_mouse"), item.mouseX, item.mouseY);
      gl.uniform1f(gl.getUniformLocation(item.simProgram, "u_mouse_active"), active);
      gl.drawArrays(gl.TRIANGLES, 0, 6);

      var temp = item.stateA;
      item.stateA = item.stateB;
      item.stateB = temp;
    }

    function draw(item, now) {
      var rect = resize(item);
      if (rect.bottom < -80 || rect.top > window.innerHeight + 80) return;
      if (!uploadBackground(item)) return;

      runSimulation(item, now);

      var gl = item.gl;
      gl.viewport(0, 0, item.canvas.width, item.canvas.height);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(item.renderProgram);
      bindQuad(gl, item.renderProgram, item.buffer);
      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, item.backgroundTexture);
      gl.uniform1i(gl.getUniformLocation(item.renderProgram, "u_background"), 0);
      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, item.stateA.texture);
      gl.uniform1i(gl.getUniformLocation(item.renderProgram, "u_state"), 1);
      gl.uniform2f(gl.getUniformLocation(item.renderProgram, "u_resolution"), item.canvas.width, item.canvas.height);
      gl.uniform1f(gl.getUniformLocation(item.renderProgram, "u_opacity"), item.section.classList.contains("la-detroit-hero") ? 0.82 : 0.66);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
    }

    function render() {
      var now = (window.performance ? window.performance.now() : Date.now()) / 1000;
      items.forEach(function (item) {
        draw(item, now);
      });
      window.requestAnimationFrame(render);
    }

    document.addEventListener("pointermove", function (event) {
      if (!desktopMedia.matches) return;
      var now = (window.performance ? window.performance.now() : Date.now()) / 1000;
      items.forEach(function (item) {
        var rect = item.section.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) return;
        item.mouseX = (event.clientX - rect.left) / rect.width;
        item.mouseY = 1 - (event.clientY - rect.top) / rect.height;
        item.mouseActive = 1;
        item.lastMove = now;
      });
    }, { passive: true });

    window.addEventListener("resize", function () {
      items.forEach(resize);
    });

    items.forEach(resize);
    render();
  }

  if (!prefersReducedMotion && window.matchMedia("(pointer: fine)").matches) {
    (function initThemeWaterRipples() {
      function initTransparentThemeRipples(desktopMedia) {
        var sections = Array.prototype.slice.call(
          document.querySelectorAll(
            "#MainContent .shopify-section > section, " +
            "#MainContent .la-portfolio-index-hero, " +
            "#MainContent .la-signal-band"
          )
        ).filter(function (section, index, list) {
          return section &&
            list.indexOf(section) === index &&
            !section.closest(".site-header") &&
            !section.closest(".site-footer") &&
            section.tagName.toLowerCase() !== "footer";
        }).sort(function (a, b) {
          if (a.contains(b)) return 1;
          if (b.contains(a)) return -1;
          return 0;
        });

        if (!sections.length) return;

        document.querySelectorAll(".la-liquid-bg-canvas, .la-liquid-lens, #la-liquid-displace-svg").forEach(function (node) {
          if (node.parentNode) node.parentNode.removeChild(node);
        });

        var surfaces = sections.map(function (section) {
          var canvas = section.querySelector(":scope > .la-water-ripple-surface");

          section.classList.add("la-water-ripple-section");

          if (!canvas) {
            canvas = document.createElement("canvas");
            canvas.className = "la-water-ripple-surface";
            canvas.setAttribute("aria-hidden", "true");
            section.insertBefore(canvas, section.firstChild);
          }

          return {
            section: section,
            canvas: canvas,
            ctx: canvas.getContext("2d", { alpha: true }),
            ripples: [],
            lastDrop: 0,
            lastX: 0,
            lastY: 0
          };
        }).filter(function (surface) {
          return surface.ctx;
        });

        if (!surfaces.length) return;

        function resize(surface) {
          var rect = surface.section.getBoundingClientRect();
          var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
          var width = Math.max(1, Math.round(rect.width * dpr));
          var height = Math.max(1, Math.round(rect.height * dpr));

          if (surface.canvas.width !== width || surface.canvas.height !== height) {
            surface.canvas.width = width;
            surface.canvas.height = height;
          }

          surface.canvas.style.width = rect.width + "px";
          surface.canvas.style.height = rect.height + "px";
          surface.dpr = dpr;
        }

        function locateSurface(clientX, clientY) {
          for (var index = 0; index < surfaces.length; index += 1) {
            var surface = surfaces[index];
            var rect = surface.section.getBoundingClientRect();

            if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
              return { surface: surface, rect: rect };
            }
          }

          return null;
        }

        function addRipple(surface, rect, clientX, clientY, now) {
          var dpr = surface.dpr || 1;
          var x = (clientX - rect.left) * dpr;
          var y = (clientY - rect.top) * dpr;
          var dx = x - surface.lastX;
          var dy = y - surface.lastY;
          var speed = Math.min(Math.sqrt(dx * dx + dy * dy), 90 * dpr);

          surface.lastX = x;
          surface.lastY = y;

          surface.ripples.push({
            x: x,
            y: y,
            vx: dx * 0.014,
            vy: dy * 0.014,
            born: now,
            power: 0.42 + speed / (180 * dpr),
            angle: Math.atan2(dy, dx)
          });

          if (surface.ripples.length > 34) {
            surface.ripples.splice(0, surface.ripples.length - 34);
          }
        }

        function drawRipple(ctx, ripple, age, dpr) {
          var duration = 2.7;
          var progress = Math.min(age / duration, 1);
          var life = Math.max(0, 1 - progress);
          var ease = Math.pow(progress, 0.92);
          var x = ripple.x + ripple.vx * age * 22;
          var y = ripple.y + ripple.vy * age * 22;
          var head = (12 + ease * 30) * dpr;
          var radius = (20 + ease * 340) * dpr * ripple.power;
          var tailRadius = radius * 1.42;
          var alpha = Math.min(1, life * ripple.power * 1.45);
          var stretchX = 1 + Math.min(Math.abs(ripple.vx) * 0.018, 0.42);
          var stretchY = 1 - Math.min(Math.abs(ripple.vy) * 0.006, 0.16);

          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(ripple.angle || 0);
          ctx.scale(stretchX, stretchY);

          ctx.lineCap = "round";
          ctx.lineJoin = "round";

          ctx.lineWidth = Math.max(1, 3.4 * dpr);
          ctx.strokeStyle = "rgba(255,255,255," + (0.24 * alpha) + ")";
          ctx.beginPath();
          ctx.arc(-2 * dpr, -2 * dpr, radius * 0.98, -0.04, Math.PI * 1.34);
          ctx.stroke();

          ctx.lineWidth = Math.max(1, 1.45 * dpr);
          ctx.strokeStyle = "rgba(255,255,255," + (0.46 * alpha) + ")";
          ctx.beginPath();
          ctx.arc(0, 0, radius, -0.06, Math.PI * 1.28);
          ctx.stroke();

          ctx.lineWidth = Math.max(1, 2.8 * dpr);
          ctx.strokeStyle = "rgba(10,12,12," + (0.13 * alpha) + ")";
          ctx.beginPath();
          ctx.arc(6 * dpr, 7 * dpr, radius * 0.9, Math.PI * 0.16, Math.PI * 1.02);
          ctx.stroke();

          ctx.lineWidth = Math.max(1, 1.7 * dpr);
          ctx.strokeStyle = "rgba(255,255,255," + (0.22 * alpha) + ")";
          ctx.beginPath();
          ctx.arc(0, 0, tailRadius, Math.PI * 1.02, Math.PI * 1.74);
          ctx.stroke();

          ctx.lineWidth = Math.max(1, 1.15 * dpr);
          ctx.strokeStyle = "rgba(255,255,255," + (0.34 * alpha) + ")";
          ctx.beginPath();
          ctx.arc(-8 * dpr, -7 * dpr, radius * 0.58, Math.PI * 1.05, Math.PI * 1.55);
          ctx.stroke();

          ctx.fillStyle = "rgba(255,255,255," + (0.13 * alpha) + ")";
          ctx.beginPath();
          ctx.ellipse(0, 0, head * 1.45, head * 0.76, 0, 0, Math.PI * 2);
          ctx.fill();

          ctx.fillStyle = "rgba(10,12,12," + (0.045 * alpha) + ")";
          ctx.beginPath();
          ctx.ellipse(5 * dpr, 7 * dpr, head * 1.32, head * 0.7, 0, 0, Math.PI * 2);
          ctx.fill();

          ctx.restore();
        }

        function render(nowMs) {
          var now = nowMs / 1000;
          var hasActiveRipples = false;

          surfaces.forEach(function (surface) {
            resize(surface);

            var ctx = surface.ctx;
            ctx.clearRect(0, 0, surface.canvas.width, surface.canvas.height);
            surface.ripples = surface.ripples.filter(function (ripple) {
              return now - ripple.born < 2.35;
            });

            if (surface.ripples.length) {
              hasActiveRipples = true;
              ctx.globalCompositeOperation = "source-over";
              surface.ripples.forEach(function (ripple) {
                drawRipple(ctx, ripple, now - ripple.born, surface.dpr || 1);
              });
            }
          });

          if (hasActiveRipples) {
            window.requestAnimationFrame(render);
          } else {
            render.isRunning = false;
          }
        }

        function requestRender() {
          if (render.isRunning) return;
          render.isRunning = true;
          window.requestAnimationFrame(render);
        }

        function handlePointerMove(event) {
          if (!desktopMedia.matches) return;

          var found = locateSurface(event.clientX, event.clientY);
          if (!found) return;

          var now = (window.performance ? window.performance.now() : Date.now()) / 1000;
          var surface = found.surface;
          var distance = Math.sqrt(
            Math.pow(event.clientX - (surface.lastClientX || event.clientX), 2) +
            Math.pow(event.clientY - (surface.lastClientY || event.clientY), 2)
          );

          surface.lastClientX = event.clientX;
          surface.lastClientY = event.clientY;

          if (now - surface.lastDrop < 0.042 && distance < 20) return;

          surface.lastDrop = now;
          addRipple(surface, found.rect, event.clientX, event.clientY, now);
          requestRender();
        }

        document.addEventListener("pointermove", handlePointerMove, { passive: true });

        surfaces.forEach(function (surface) {
          surface.section.addEventListener("pointermove", handlePointerMove, { passive: true });
        });

        window.addEventListener("resize", function () {
          surfaces.forEach(resize);
        });

        surfaces.forEach(resize);
      }

      var desktopMedia = window.matchMedia("(min-width: 981px)");
      if (!desktopMedia.matches) return;

      initTransparentThemeRipples(desktopMedia);
      return;

      Array.prototype.forEach.call(document.querySelectorAll(".la-water-ripple-surface"), function (canvas) {
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      });

      var lens = document.querySelector(".la-liquid-lens");

      if (!lens) {
        lens = document.createElement("div");
        lens.className = "la-liquid-lens";
        lens.setAttribute("aria-hidden", "true");
        document.body.appendChild(lens);
      }

      if (!document.getElementById("la-liquid-displace-svg")) {
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        var filter = document.createElementNS("http://www.w3.org/2000/svg", "filter");
        var turbulence = document.createElementNS("http://www.w3.org/2000/svg", "feTurbulence");
        var displacement = document.createElementNS("http://www.w3.org/2000/svg", "feDisplacementMap");

        svg.setAttribute("id", "la-liquid-displace-svg");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("width", "0");
        svg.setAttribute("height", "0");
        svg.setAttribute("focusable", "false");
        svg.style.position = "absolute";
        svg.style.width = "0";
        svg.style.height = "0";
        svg.style.overflow = "hidden";

        filter.setAttribute("id", "la-liquid-displace");
        filter.setAttribute("x", "-20%");
        filter.setAttribute("y", "-20%");
        filter.setAttribute("width", "140%");
        filter.setAttribute("height", "140%");

        turbulence.setAttribute("type", "fractalNoise");
        turbulence.setAttribute("baseFrequency", "0.018 0.028");
        turbulence.setAttribute("numOctaves", "3");
        turbulence.setAttribute("seed", "8");
        turbulence.setAttribute("result", "noise");

        displacement.setAttribute("in", "SourceGraphic");
        displacement.setAttribute("in2", "noise");
        displacement.setAttribute("scale", "58");
        displacement.setAttribute("xChannelSelector", "R");
        displacement.setAttribute("yChannelSelector", "G");

        filter.appendChild(turbulence);
        filter.appendChild(displacement);
        svg.appendChild(filter);
        document.body.appendChild(svg);
      }

      var targetX = window.innerWidth * 0.5;
      var targetY = window.innerHeight * 0.5;
      var currentX = targetX;
      var currentY = targetY;
      var previousX = currentX;
      var previousY = currentY;
      var raf = null;
      var hideTimer = null;

      function setLiquidVars() {
        var dx = currentX - previousX;
        var dy = currentY - previousY;
        var speed = Math.min(Math.sqrt(dx * dx + dy * dy), 58);
        var angle = Math.atan2(dy, dx) * 180 / Math.PI;
        var stretch = speed / 58;

        previousX = currentX;
        previousY = currentY;

        lens.style.setProperty("--lens-x", currentX + "px");
        lens.style.setProperty("--lens-y", currentY + "px");
        lens.style.setProperty("--lens-rotate", angle + "deg");
        lens.style.setProperty("--lens-scale-x", 1 + stretch * 0.22);
        lens.style.setProperty("--lens-scale-y", 1 - stretch * 0.1);
        lens.style.setProperty("--lens-flow", stretch);
      }

      function renderLiquidLens() {
        currentX += (targetX - currentX) * 0.16;
        currentY += (targetY - currentY) * 0.16;
        setLiquidVars();

        if (Math.abs(targetX - currentX) > 0.2 || Math.abs(targetY - currentY) > 0.2) {
          raf = window.requestAnimationFrame(renderLiquidLens);
        } else {
          raf = null;
        }
      }

      function requestLiquidFrame() {
        if (!raf) raf = window.requestAnimationFrame(renderLiquidLens);
      }

      document.addEventListener(
        "pointermove",
        function (event) {
          if (!desktopMedia.matches) return;

          targetX = event.clientX;
          targetY = event.clientY;
          lens.classList.add("is-active");
          document.body.classList.add("is-liquid-lens-active");

          if (hideTimer) window.clearTimeout(hideTimer);
          hideTimer = window.setTimeout(function () {
            lens.classList.remove("is-active");
            document.body.classList.remove("is-liquid-lens-active");
          }, 1100);

          requestLiquidFrame();
        },
        { passive: true }
      );

      document.addEventListener("pointerleave", function () {
        lens.classList.remove("is-active");
        document.body.classList.remove("is-liquid-lens-active");
      });

      window.addEventListener("resize", requestLiquidFrame);
      return;

      var supportsWebGL = !!document.createElement("canvas").getContext("webgl");
      if (!supportsWebGL) return;

      var sections = Array.prototype.slice.call(
        document.querySelectorAll("main .shopify-section > section, main section.la-scroll-section")
      ).filter(function (section, index, list) {
        return section && list.indexOf(section) === index;
      });

      var vertexSource =
        "attribute vec2 a_position;" +
        "varying vec2 v_uv;" +
        "void main(){v_uv=(a_position+1.0)*0.5;gl_Position=vec4(a_position,0.0,1.0);}";

      var fragmentSource =
        "precision mediump float;" +
        "varying vec2 v_uv;" +
        "uniform vec2 u_resolution;" +
        "uniform float u_time;" +
        "uniform int u_count;" +
        "uniform vec3 u_ripples[18];" +
        "float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453123);}" +
        "float noise(vec2 p){vec2 i=floor(p);vec2 f=fract(p);vec2 u=f*f*(3.0-2.0*f);return mix(mix(hash(i),hash(i+vec2(1.0,0.0)),u.x),mix(hash(i+vec2(0.0,1.0)),hash(i+vec2(1.0,1.0)),u.x),u.y);}" +
        "void main(){" +
        "vec2 pos=v_uv*u_resolution;" +
        "float field=0.0;" +
        "float edgeField=0.0;" +
        "vec2 flow=vec2(0.0);" +
        "for(int i=0;i<18;i++){" +
        "if(i>=u_count) break;" +
        "vec3 r=u_ripples[i];" +
        "float age=max(u_time-r.z,0.0);" +
        "vec2 d=pos-r.xy;" +
        "float dist=length(d)+0.001;" +
        "float life=exp(-age*1.05);" +
        "float radius=(118.0+34.0*sin(age*2.2))*life;" +
        "float pull=(radius*radius)/(dist*dist+radius*radius*0.38);" +
        "field+=pull*life;" +
        "edgeField+=smoothstep(radius*1.22,radius*0.58,dist)*life;" +
        "flow+=normalize(d)*pull*life;" +
        "}" +
        "float mask=smoothstep(0.42,0.86,field);" +
        "float edge=smoothstep(0.45,0.82,field)-smoothstep(0.92,1.38,field);" +
        "vec2 n=normalize(flow+vec2(0.001));" +
        "float rim=pow(clamp(dot(n,normalize(vec2(-0.72,-0.38)))*0.5+0.5,0.0,1.0),2.2);" +
        "float caustic=sin((pos.x+n.x*70.0)*0.032+u_time*2.2)+sin((pos.y+n.y*90.0)*0.026-u_time*1.8);" +
        "caustic+=noise(pos*0.018+flow*0.035+u_time*0.2)*2.0-1.0;" +
        "float inner=clamp(caustic*0.09+field*0.05,0.0,0.22);" +
        "float alpha=clamp(mask*0.10+edge*0.32+rim*edge*0.38+inner*mask,0.0,0.54);" +
        "vec3 glass=vec3(0.94,0.90,0.80);" +
        "vec3 shadow=vec3(0.02,0.025,0.024);" +
        "vec3 color=mix(shadow,glass,clamp(0.48+rim*0.72+edge*0.6+inner,0.0,1.0));" +
        "color+=vec3(1.0,0.94,0.78)*pow(edge,2.0)*0.65;" +
        "gl_FragColor=vec4(color,alpha);" +
        "}";

      function compileShader(gl, type, source) {
        var shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
        return shader;
      }

      function createWaterProgram(canvas) {
        var gl = canvas.getContext("webgl", {
          alpha: true,
          antialias: true,
          depth: false,
          stencil: false,
          premultipliedAlpha: true
        });

        if (!gl) return null;

        var vertexShader = compileShader(gl, gl.VERTEX_SHADER, vertexSource);
        var fragmentShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSource);
        if (!vertexShader || !fragmentShader) return null;

        var program = gl.createProgram();
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;

        var buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(
          gl.ARRAY_BUFFER,
          new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
          gl.STATIC_DRAW
        );

        var position = gl.getAttribLocation(program, "a_position");
        var resolution = gl.getUniformLocation(program, "u_resolution");
        var time = gl.getUniformLocation(program, "u_time");
        var count = gl.getUniformLocation(program, "u_count");
        var ripples = gl.getUniformLocation(program, "u_ripples");

        return {
          gl: gl,
          program: program,
          position: position,
          resolution: resolution,
          time: time,
          count: count,
          ripples: ripples,
          sources: [],
          lastDrop: 0
        };
      }

      var surfaces = sections.map(function (section) {
        var canvas = section.querySelector(":scope > .la-water-ripple-surface");

        section.classList.add("la-water-ripple-section");

        if (!canvas) {
          canvas = document.createElement("canvas");
          canvas.className = "la-water-ripple-surface";
          canvas.setAttribute("aria-hidden", "true");
          section.insertBefore(canvas, section.firstChild);
        }

        return {
          section: section,
          canvas: canvas,
          renderer: createWaterProgram(canvas)
        };
      }).filter(function (item) {
        return item.renderer;
      });

      var activeSurface = null;
      var raf = null;

      function resizeSurface(item) {
        var rect = item.section.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 1.75);
        var width = Math.max(1, Math.round(rect.width * dpr));
        var height = Math.max(1, Math.round(rect.height * dpr));

        if (item.canvas.width !== width || item.canvas.height !== height) {
          item.canvas.width = width;
          item.canvas.height = height;
        }

        item.canvas.style.width = rect.width + "px";
        item.canvas.style.height = rect.height + "px";
      }

      function findSurface(x, y) {
        for (var index = 0; index < surfaces.length; index += 1) {
          var item = surfaces[index];
          var rect = item.section.getBoundingClientRect();

          if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
            return { item: item, rect: rect };
          }
        }

        return null;
      }

      function drawSurface(item, now) {
        var renderer = item.renderer;
        var gl = renderer.gl;
        var sources = renderer.sources.filter(function (source) {
          return now - source.t < 3.2;
        });

        renderer.sources = sources;
        resizeSurface(item);

        gl.viewport(0, 0, item.canvas.width, item.canvas.height);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(renderer.program);
        gl.enableVertexAttribArray(renderer.position);
        gl.vertexAttribPointer(renderer.position, 2, gl.FLOAT, false, 0, 0);
        gl.uniform2f(renderer.resolution, item.canvas.width, item.canvas.height);
        gl.uniform1f(renderer.time, now);
        gl.uniform1i(renderer.count, sources.length);

        var data = new Float32Array(18 * 3);
        sources.forEach(function (source, index) {
          data[index * 3] = source.x;
          data[index * 3 + 1] = source.y;
          data[index * 3 + 2] = source.t;
        });

        gl.uniform3fv(renderer.ripples, data);
        gl.drawArrays(gl.TRIANGLES, 0, 6);

        item.section.classList.toggle("is-water-active", sources.length > 0);
        return sources.length > 0;
      }

      function render() {
        var now = (window.performance ? window.performance.now() : Date.now()) / 1000;
        var hasActiveRipples = false;

        surfaces.forEach(function (item) {
          if (drawSurface(item, now)) hasActiveRipples = true;
        });

        raf = hasActiveRipples ? window.requestAnimationFrame(render) : null;
      }

      function requestRender() {
        if (!raf) raf = window.requestAnimationFrame(render);
      }

      document.addEventListener(
        "pointermove",
        function (event) {
          if (!desktopMedia.matches) return;

          var target = findSurface(event.clientX, event.clientY);
          if (!target) return;

          var item = target.item;
          var renderer = item.renderer;
          var nowMs = window.performance ? window.performance.now() : Date.now();
          var dpr = Math.min(window.devicePixelRatio || 1, 1.75);

          activeSurface = item;

          if (nowMs - renderer.lastDrop < 42) {
            requestRender();
            return;
          }

          renderer.lastDrop = nowMs;
          renderer.sources.push({
            x: (event.clientX - target.rect.left) * dpr,
            y: (target.rect.height - (event.clientY - target.rect.top)) * dpr,
            t: nowMs / 1000
          });

          while (renderer.sources.length > 18) {
            renderer.sources.shift();
          }

          requestRender();
        },
        { passive: true }
      );

      window.addEventListener("resize", function () {
        surfaces.forEach(resizeSurface);
        requestRender();
      });
    })();

    document.addEventListener("pointermove", function (event) {
      document.body.classList.add("la-pointer-active");
      cursorGlow.style.transform =
        "translate3d(" +
        event.clientX +
        "px, " +
        event.clientY +
        "px, 0) translate(-50%, -50%)";
    });

    document.addEventListener("pointerleave", function () {
      document.body.classList.remove("la-pointer-active");
    });

    document.querySelectorAll(".la-tilt-card").forEach(function (card) {
      card.addEventListener("pointermove", function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;

        card.style.setProperty("--tilt-x", (x * 7).toFixed(2) + "deg");
        card.style.setProperty("--tilt-y", (y * -7).toFixed(2) + "deg");
      });

      card.addEventListener("pointerleave", function () {
        card.style.removeProperty("--tilt-x");
        card.style.removeProperty("--tilt-y");
      });
    });

    document.querySelectorAll(".la-shine-card").forEach(function (card) {
      card.addEventListener("pointermove", function (event) {
        var rect = card.getBoundingClientRect();

        card.style.setProperty(
          "--shine-x",
          (((event.clientX - rect.left) / rect.width) * 100).toFixed(2) + "%"
        );

        card.style.setProperty(
          "--shine-y",
          (((event.clientY - rect.top) / rect.height) * 100).toFixed(2) + "%"
        );
      });
    });
  }

  if (!prefersReducedMotion) {
    var parallaxItems = document.querySelectorAll("[data-parallax]");

    function syncParallax() {
      parallaxItems.forEach(function (item) {
        var speed = Number(item.getAttribute("data-parallax")) || 0.06;
        var rect = item.getBoundingClientRect();
        var offset = (window.innerHeight / 2 - (rect.top + rect.height / 2)) * speed;

        item.style.transform = "translateY(" + offset.toFixed(2) + "px)";
      });
    }

    if (parallaxItems.length) {
      syncParallax();
      window.addEventListener("scroll", syncParallax, { passive: true });
      window.addEventListener("resize", syncParallax);
    }
  }

  if (menuToggle) {
    menuToggle.addEventListener("click", function (event) {
      event.preventDefault();
      toggleMobileMenu();
    });
  }

  if (menuClose) {
    menuClose.addEventListener("click", function (event) {
      event.preventDefault();
      closeMobileMenu();
    });
  }

  if (mobileBackdrop) {
    mobileBackdrop.addEventListener("click", function (event) {
      event.preventDefault();
      closeMobileMenu();
    });
  }

  if (mobileSearchForm && mobileSearchToggle) {
    mobileSearchToggle.addEventListener("click", function (event) {
      if (!mobileSearchForm.classList.contains("is-active")) {
        event.preventDefault();
        openMobileSearch();
        return;
      }

      if (!mobileSearchInput || !mobileSearchInput.value.trim()) {
        event.preventDefault();
        if (mobileSearchInput) mobileSearchInput.focus();
      }
    });
  }

  if (mobileNav) {
    mobileNav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeMobileMenu);
    });
  }

  /* =========================================================
     FINAL FIX:
     點擊 close、背景遮罩、或選單外部時，都可以關閉 mobile menu
  ========================================================= */

  document.addEventListener(
    "click",
    function (event) {
      if (!body.classList.contains("mobile-menu-open")) return;

      var clickedInsideMenu = event.target.closest("[data-mobile-nav]");
      var clickedToggle = event.target.closest("[data-mobile-toggle]");
      var clickedClose = event.target.closest("[data-mobile-close]");
      var clickedBackdrop = event.target.closest("[data-mobile-backdrop]");

      if (clickedClose || clickedBackdrop) {
        event.preventDefault();
        closeMobileMenu();
        return;
      }

      if (!clickedInsideMenu && !clickedToggle) {
        closeMobileMenu();
      }
    },
    true
  );

  document.querySelectorAll("[data-slide]").forEach(function (slider) {
    var row = slider.querySelector("[data-slide-row]");
    var parent = slider.closest("section");
    var previous = parent ? parent.querySelector("[data-slide-prev]") : null;
    var next = parent ? parent.querySelector("[data-slide-next]") : null;

    if (!row) return;

    function slideBy(direction) {
      var firstCard = row.querySelector(".la-slide-card");
      var distance = firstCard ? firstCard.getBoundingClientRect().width + 18 : row.clientWidth * 0.82;

      row.scrollBy({
        left: distance * direction,
        behavior: "smooth"
      });
    }

    if (previous) {
      previous.addEventListener("click", function () {
        slideBy(-1);
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        slideBy(1);
      });
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMobileMenu();
  });

  var revealItems = document.querySelectorAll("[data-reveal]");

  if ("IntersectionObserver" in window && revealItems.length) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach(function (item) {
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add("is-visible");
    });
  }

  var filterRoot = document.querySelector("[data-portfolio-filter]");

  if (filterRoot) {
    var searchInput = filterRoot.querySelector("[data-portfolio-search]");
    var tagButtons = filterRoot.querySelectorAll("[data-portfolio-tag]");
    var cards = document.querySelectorAll("[data-portfolio-card]");
    var emptyState = document.querySelector("[data-portfolio-empty]");
    var activeTag = "";

    function applyPortfolioFilter() {
      var query = searchInput ? searchInput.value.trim().toLowerCase() : "";
      var visibleCount = 0;

      cards.forEach(function (card) {
        var title = (card.getAttribute("data-title") || "").toLowerCase();
        var excerpt = (card.getAttribute("data-excerpt") || "").toLowerCase();
        var tags = (card.getAttribute("data-tags") || "").split(",");

        var matchesQuery = !query || title.indexOf(query) > -1 || excerpt.indexOf(query) > -1;
        var matchesTag = !activeTag || tags.indexOf(activeTag) > -1;
        var visible = matchesQuery && matchesTag;

        card.classList.toggle("hidden", !visible);

        if (visible) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.classList.toggle("hidden", visibleCount !== 0);
      }
    }

    if (searchInput) {
      searchInput.addEventListener("input", applyPortfolioFilter);
    }

    tagButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeTag = button.getAttribute("data-portfolio-tag") || "";

        tagButtons.forEach(function (item) {
          var isActive = item === button;

          item.setAttribute("aria-pressed", isActive ? "true" : "false");
          item.classList.toggle("bg-primary", isActive);
          item.classList.toggle("text-primary-foreground", isActive);
          item.classList.toggle("bg-secondary", !isActive);
          item.classList.toggle("text-muted-foreground", !isActive);
        });

        applyPortfolioFilter();
      });
    });
  }

  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var sectionId = form.getAttribute("data-product-form");
    var variantsScript = document.querySelector('[data-product-variants="' + sectionId + '"]');
    var variantInput = form.querySelector("[data-variant-id]");
    var submitButton = form.querySelector(".la-product-submit");
    var priceEl = document.getElementById("ProductPrice-" + sectionId);
    var comparePriceEl = document.getElementById("ProductComparePrice-" + sectionId);

    if (!variantsScript || !variantInput) return;

    var variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent || "[]");
    } catch (error) {
      variants = [];
    }

    function formatMoney(cents) {
      var currency = form.getAttribute("data-currency") || "TWD";

      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat("zh-TW", {
        style: "currency",
        currency: currency,
        maximumFractionDigits: 0
      }).format((cents || 0) / 100);
    }

    function selectedOptions() {
      var values = [];

      form.querySelectorAll(".la-product-options fieldset").forEach(function (fieldset) {
        var checked = fieldset.querySelector("input:checked");

        if (checked) {
          values.push(checked.value);
        }
      });

      return values;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function updateVariant() {
      var variant = findVariant(selectedOptions()) || variants[0];

      if (!variant) return;

      variantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? themeStrings.addToCart : themeStrings.soldOut;
      }
    }

    form.querySelectorAll(".la-product-options input").forEach(function (input) {
      input.addEventListener("change", updateVariant);
    });

    updateVariant();
  });
})();
